<template>
  <div
    class="main-menu menu-fixed menu-accordion menu-shadow"
    :class="[
      {
        expanded:
          !isVerticalMenuCollapsed ||
          (isVerticalMenuCollapsed && isMouseHovered),
      },
      skin === 'semi-dark' ? 'menu-dark' : 'menu-light',
    ]"
    @mouseenter="updateMouseHovered(true)"
    @mouseleave="updateMouseHovered(false)"
  >
    <!-- main menu header-->
    <div class="navbar-header expanded">
      <slot
        name="header"
        :toggleVerticalMenuActive="toggleVerticalMenuActive"
        :toggleCollapsed="toggleCollapsed"
        :collapseTogglerIcon="collapseTogglerIcon"
      >
        <ul class="nav navbar-nav flex-row">
          <!-- Logo & Text -->
          <li class="nav-item mr-auto">
            <b-link class="navbar-brand" to="/">
              <span class="brand-logo">
                <!-- <b-img
                  src="/favicon.ico"
                  alt="logo"
                  width="40"
                /> -->
                <img
                  v-if="windowLocation === 'https://report.kimchibet.com/'"
                  src="/favicon-kc.ico"
                  width="40"
                />
                <img v-else src="/logoreport.webp" width="40"/>
              </span>
              <h2 class="brand-text name-logo">
                REPORT<span class="txt-se"></span>
              </h2>
            </b-link>
          </li>

          <!-- Toggler Button -->
          <!-- <li class="nav-item nav-toggle">
            <b-link class="nav-link modern-nav-toggle">
              <i
                class="fa-brands fa-elementor fa-2x d-block d-xl-none"
                style="margin-top: -5px;"
                @click="toggleVerticalMenuActive"
              />
              <i
                class="fa-brands fa-elementor fa-2x d-none d-xl-block collapse-toggle-icon"
                style="margin-top: -8px;"
                @click="toggleCollapsed"
              />
            </b-link>
          </li> -->
        </ul>
      </slot>
    </div>
    <!-- / main menu header-->
    <!-- box name agent -->
    <div class="box-ag">
      <h5 class="mb-0 text-white text-center">
        <u>My Account</u>
      </h5>

      <div class="d-flex justify-content-between">
        <p class="mb-0"><i class="fa-solid fa-circle-user" /> username</p>
        <p class="mb-0">
          {{ userData.username }}
        </p>
      </div>

      <div class="d-flex justify-content-between">
        <p class="mb-0"><i class="fa-solid fa-address-card" /> role</p>
        <p class="mb-0">
          {{ userData.role }}
        </p>
      </div>

      <div class="d-flex justify-content-between">
        <p class="mb-0"><i class="fa-solid fa-wallet" /> seamless</p>
        <p class="mb-0">0</p>
      </div>
    </div>
    <!-- Shadow -->
    <div :class="{ 'd-block': shallShadowBottom }" class="shadow-bottom" />

    <!-- main menu content-->
    <vue-perfect-scrollbar
      :settings="perfectScrollbarSettings"
      class="main-menu-content scroll-area"
      tagname="ul"
      @ps-scroll-y="
        (evt) => {
          shallShadowBottom = evt.srcElement.scrollTop > 0;
        }
      "
    >
      <vertical-nav-menu-items
        :items="navMenuItems"
        class="navigation navigation-main"
      />
    </vue-perfect-scrollbar>
    <!-- /main menu content-->
  </div>
</template>

<script>
import navMenuItems from "@/navigation/vertical";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import { BLink, BImg } from "bootstrap-vue";
import { provide, computed, ref } from "@vue/composition-api";
import useAppConfig from "@core/app-config/useAppConfig";
import { $themeConfig } from "@themeConfig";
import VerticalNavMenuItems from "./components/vertical-nav-menu-items/VerticalNavMenuItems.vue";
import useVerticalNavMenu from "./useVerticalNavMenu";

export default {
  components: {
    VuePerfectScrollbar,
    VerticalNavMenuItems,
    BLink,
    BImg,
  },
  props: {
    isVerticalMenuActive: {
      type: Boolean,
      required: true,
    },
    toggleVerticalMenuActive: {
      type: Function,
      required: true,
    },
  },
  setup(props) {
    const {
      isMouseHovered,
      isVerticalMenuCollapsed,
      collapseTogglerIcon,
      toggleCollapsed,
      updateMouseHovered,
    } = useVerticalNavMenu(props);

    const { skin } = useAppConfig();

    // Shadow bottom is UI specific and can be removed by user => It's not in `useVerticalNavMenu`
    const shallShadowBottom = ref(false);

    provide("isMouseHovered", isMouseHovered);

    const perfectScrollbarSettings = {
      maxScrollbarLength: 60,
      wheelPropagation: false,
    };

    const collapseTogglerIconFeather = computed(() =>
      collapseTogglerIcon.value === "unpinned" ? "CircleIcon" : "DiscIcon"
    );

    // App Name
    const { appName, appLogoImage } = $themeConfig.app;

    return {
      navMenuItems,
      perfectScrollbarSettings,
      isVerticalMenuCollapsed,
      collapseTogglerIcon,
      toggleCollapsed,
      isMouseHovered,
      updateMouseHovered,
      collapseTogglerIconFeather,

      // Shadow Bottom
      shallShadowBottom,

      // Skin
      skin,

      // App Name
      appName,
      appLogoImage,
      userData: JSON.parse(localStorage.getItem("userData")),
    };
  },
};
</script>

<style>
.name-logo {
  font-family: "Russo One", sans-serif;
  font-size: 1.5rem;
}
.txt-se {
  font-family: "Russo One", sans-serif;
  font-size: 14px;
}
</style>

<style lang="scss">
@import "~@core/scss/base/core/menu/menu-types/vertical-menu.scss";
@import url("https://fonts.googleapis.com/css2?family=Russo+One&display=swap");
</style>
